import React from 'react';
import PropTypes from 'prop-types';
import { FaSpinner } from 'react-icons/fa';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Loading...', size = 'medium', inline = false }) => {
    return (
        <div 
            className={`loading-spinner-container${inline ? ' inline' : ''}`}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <FaSpinner 
                className={`loading-spinner-icon loading-spinner-${size}`}
                aria-hidden="true"
            />
            {message && (
                <div className="loading-spinner-text" aria-label={message}>
                    {message}
                </div>
            )}
        </div>
    );
};

LoadingSpinner.propTypes = {
    message: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    inline: PropTypes.bool
};

export default LoadingSpinner;
